<!-- 赤タグ -->
<ng-container *ngIf="searchTag.tag_type == 'qoala_tag'; else elseTemplate">
  <app-tag-button [tagName]="searchTag.tag_name" [activated]="searchTag.is_activated"
    [buttonMode]="false" [color]="'red'" (tagClick)="clickQoalaTag()"></app-tag-button>
</ng-container>

<!-- 青タグ -->
<ng-template #elseTemplate>
  <app-tag-button [ngbTooltip]="searchContentsTemplate" [openDelay]="500" [container]="'body'"
    [tagName]="searchTag.tag_name" [buttonMode]="true" [color]="'blue'"
    (tagClick)="clickUserTag()" (tagDelete)="openConfirmDeleteUserTagModal(confirmDeleteUserTagModal)"></app-tag-button>
</ng-template>

<!-- tooltip template -->
<ng-template #searchContentsTemplate>
  <div class="tooltip-box d-flex flex-column">
    <ng-container *ngFor="let searchContent of searchContents(); let i = index">
      <span class="content">{{ searchContent }}</span>
    </ng-container>
  </div>
</ng-template>

<ng-template #confirmDeleteUserTagModal let-modal>
  <div class="modal-section">
    <div class="modal-header">
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
        <span class="close-button" aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body">
      <p>
        タグ名: {{ searchTag.tag_name }} <br>
        上記のタグを削除します。<br>
        削除後は取り消しできません。削除しますか？
      </p>
      <div class="d-flex justify-content-between">
        <button type="button" class="btn btn-dark" (click)="modal.dismiss()" ngbAutofocus>キャンセル</button>
        <button type="button" class="btn btn-primary-dark" (click)="deleteUserTag()">はい</button>
      </div>
    </div>
  </div>
</ng-template>
